import { getPublish as publish, applets, branding, settings } from "../actions/admin/mobile";

export const getApplets = (dispatch: any) => () => dispatch(applets());

export const getSettings = (dispatch: any) => () => dispatch(settings());

export const getBranding = (dispatch: any) => () => dispatch(branding());

export const getPublish = (dispatch: any) => () => dispatch(publish());
